/**
 * Навигация в шапке и оверлее: подсветка текущего раздела.
 */

function normalizePath(path) {
    if (!path) {
        return '/';
    }

    var normalized = String(path).split('?')[0].split('#')[0];

    if (normalized.length > 1 && normalized.charAt(normalized.length - 1) === '/') {
        normalized = normalized.slice(0, -1);
    }

    return normalized || '/';
}

function pathFromHref(href) {
    try {
        return normalizePath(new URL(href, window.location.href).pathname);
    } catch (err) {
        return normalizePath(href);
    }
}

/**
 * Подсвечивает пункты меню, соответствующие текущему URL (или переданному href).
 */
export function syncNavActive(href) {
    var currentPath = pathFromHref(href || window.location.href);
    var links = document.querySelectorAll('.museum-nav__link, .museum-menu__nav-link');

    links.forEach(function (link) {
        var linkPath = pathFromHref(link.getAttribute('href') || link.href);
        var isActive = linkPath === currentPath;

        // Карточка героя /heroes/slug → активен «Список героев»
        if (!isActive && linkPath === '/heroes' && currentPath.indexOf('/heroes/') === 0) {
            isActive = true;
        }

        link.classList.toggle('is-active', isActive);

        if (isActive) {
            link.setAttribute('aria-current', 'page');
        } else {
            link.removeAttribute('aria-current');
        }
    });
}

export function initNav() {
    syncNavActive();
}
